<template>
  <div v-if="isVisible" class="auth-required-overlay">
    <div class="modal-container">
      <div>Для продолжения необходимо Войти под своим логином</div>
      <div class="buttons">
        <button class="btn blue" @click="loginClick">Войти</button>
        <button class="btn link" @click="continueAsGuest">Остаться</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "AuthRequireDialogue",
  components: {
  },
  data() {
    return {
      isVisible: false,
      href: null,
      onResolveCallback: null
    };
  },
  created() {
    this.$root.$on("show-auth-require", this.handleShowDialogue);
  },
  beforeDestroy() {
    this.$root.$off("show-auth-require", this.handleShowDialogue);
  },
  methods: {
    handleShowDialogue({ href, onResolve }) {
      // console.log("show-captcha");
      this.href = href;
      this.onResolveCallback = onResolve;
      this.isVisible = true;
    },
    continueAsGuest() {
      this.$store.dispatch('setGuest', true);
    },
    async loginClick() {
      this.isVisible = false;
      this.$router.push('/login');
      
      // if (this.onResolveCallback) {
      //   this.isVisible = false;
      //   // Передаем управление обратно в интерцептор, который выполнит повторный запрос
      //   await this.onResolveCallback(payload.value);
      // }
    },
  },
};
</script>

<style scoped>
.auth-required-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.modal-container {
  /* background: white; */
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  max-width: 350px;
  width: 100%;

  color: white;
  background: #19191ceb;
  border-radius: 10px;
  border: 1px solid #5b5b5b;
  box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.2);
}
</style>